"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_FORMAT_DE = void 0;
exports.toDate = toDate;
exports.toNumber = toNumber;
exports.formatLength = formatLength;
exports.formatArea = formatArea;
exports.prettyName = prettyName;
exports.NUMBER_FORMAT_DE = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});
function toDate(value) {
    if (!value)
        return null;
    if (value instanceof Date)
        return value;
    if (typeof (value === null || value === void 0 ? void 0 : value.toDate) === 'function')
        return value.toDate(); // Firestore SDK Timestamp
    if (value === null || value === void 0 ? void 0 : value.seconds)
        return new Date(value.seconds * 1000); // plain { seconds }
    if (value === null || value === void 0 ? void 0 : value._seconds)
        return new Date(value._seconds * 1000); // plain { _seconds } (serialised)
    if (typeof value === 'string' || typeof value === 'number')
        return new Date(value);
    return null;
}
function toNumber(value) {
    if (typeof value === 'number' && Number.isFinite(value))
        return value;
    if (typeof value === 'string') {
        const normalized = value.replace(',', '.').trim();
        if (!normalized)
            return null;
        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : null;
    }
    return null;
}
/**
 * Format a length value (metres) as a human-readable German-locale string.
 * < 1 000 m → "X m", ≥ 1 000 m → "X,XX km"
 */
function formatLength(lengthValue, fmt = exports.NUMBER_FORMAT_DE) {
    const length = toNumber(lengthValue);
    if (length == null)
        return '';
    if (Math.abs(length) < 1000)
        return `${fmt.format(length)} m`;
    return `${fmt.format(length / 1000)} km`;
}
/**
 * Format an area value (m²) as a human-readable German-locale string.
 * Always in hectares: "X,XX ha"
 */
function formatArea(areaValue, fmt = exports.NUMBER_FORMAT_DE) {
    const area = toNumber(areaValue);
    if (area == null)
        return '';
    return `${fmt.format(area / 10000)} ha`;
}
/** Convert a camelCase field name to a space-separated title-case label. */
function prettyName(field) {
    return field
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, s => s.toUpperCase());
}
